import React from "react";
import ChatComponent from "../components/dashboard/components/ChatComponent";

export default function Chat() {
  return (
    <div className="container mx-auto px-4 py-36 h-screen">
      <div className="h-[calc(100vh-288px)]">
        <ChatComponent className="max-w-6xl mx-auto h-full" />
      </div>
    </div>
  );
}
